// extracted by mini-css-extract-plugin
export default {"popups-root":"ZGZHng","popupsRoot":"ZGZHng","popups-wrapper":"KT0IxY","popupsWrapper":"KT0IxY"};